import {Box, Stack, Typography} from "@mui/material";
import {c, mono} from "../landingTokens";
import {Section, Eyebrow} from "./Shell";
import {ProductShot} from "./ProductShot";
import designerShot from "../../../assets/images/designer.png";

const PIPELINE = [
  {
    step: "01 · TELEPHONY",
    title: "Your PBX → Asterisk",
    body: "Avaya — or whatever phone central you run — trunks into our Asterisk over standard SIP. Nothing on your side gets replaced.",
  },
  {
    step: "02 · AUDIO",
    title: "Custom SIP connector",
    body: "Our connector streams raw call audio over AudioSocket in both directions — the reason the agent answers in under a second instead of after a beep.",
  },
  {
    step: "03 · LOGIC",
    title: "The flow you designed",
    body: "Audio hits the conversation flow built in the OpenBrain app. Prompts, branches, guardrails and escalation rules live there — editable without a release.",
  },
  {
    step: "04 · ACTIONS",
    title: "Your API, via MCP",
    body: "The flow calls your systems through MCP tools and REST — checking a balance, moving an appointment, opening a ticket while the caller is still on the line.",
  },
];

const STACK = ["SIP trunk", "Asterisk", "AudioSocket", "Flow designer", "MCP tools", "REST / webhooks"];

export const Integrations = () => (
  <Section id="integrations" label="Integrations">
    <Box sx={{bgcolor: c.bgSoft, border: `1px solid ${c.line}`, borderRadius: "34px", p: "clamp(32px, 5vw, 62px)"}}>
      <Eyebrow>Integrations</Eyebrow>
      <Typography component="h2" sx={{fontSize: "clamp(30px, 4.2vw, 50px)", lineHeight: 1.05, letterSpacing: "-0.03em", fontWeight: 600, maxWidth: 700, mb: 1.5, textWrap: "balance"}}>
        Four hops from your phone central to your API.
      </Typography>
      <Typography sx={{fontSize: 17, lineHeight: 1.5, color: c.inkSoft, maxWidth: 580, mb: 5.5}}>
        No rip-and-replace. Your PBX keeps doing its job — we sit next to it over SIP and reach your systems through a flow you can see and edit.
      </Typography>

      <Box sx={{display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(228px, 1fr))", gap: 1.75}}>
        {PIPELINE.map((s) => (
          <Box key={s.step} sx={{bgcolor: c.white, border: `1px solid ${c.line}`, borderRadius: "20px", p: 3}}>
            <Typography sx={{fontFamily: mono, fontSize: 11, color: c.purpleDeep, letterSpacing: "0.08em"}}>{s.step}</Typography>
            <Typography sx={{fontSize: 19, letterSpacing: "-0.015em", fontWeight: 600, mt: 1.75, mb: 1}}>{s.title}</Typography>
            <Typography sx={{fontSize: "14.5px", lineHeight: 1.5, color: c.inkSoft}}>{s.body}</Typography>
          </Box>
        ))}
      </Box>

      <Stack direction="row" flexWrap="wrap" useFlexGap alignItems="center" gap={1.75} sx={{mt: 1.75, bgcolor: c.white, border: `1px solid ${c.line}`, borderRadius: "20px", p: 3}}>
        <Typography sx={{fontFamily: mono, fontSize: 11, color: c.inkMuted, letterSpacing: "0.08em", mr: 0.5}}>STACK</Typography>
        {STACK.map((tag) => (
          <Box
            key={tag}
            sx={{
              fontSize: "12.5px",
              fontWeight: 500,
              bgcolor: "rgba(132,145,247,0.14)",
              color: c.purpleInk,
              px: 1.625,
              py: 0.75,
              borderRadius: "980px",
            }}
          >
            {tag}
          </Box>
        ))}
      </Stack>

      <Box sx={{mt: 1.75}}>
        <ProductShot src={designerShot} alt="OpenBrain flow designer canvas" ratio="21 / 8" />
      </Box>
    </Box>
  </Section>
);
